import React, { useState } from 'react';
import { CloseIcon } from '../Icons/Icons';
import './PropertyTrends.css';

function PropertyTrends({ onClose }) {
  const [selectedCity, setSelectedCity] = useState('Karachi');

  const trendsData = {
    Karachi: {
      avgPrice: 'PKR 1.2 Crore',
      growth: '+8.5%',
      mostPopular: 'DHA Phase 6',
      transactions: '2,847',
      priceHistory: [
        { month: 'Jan', price: 11000000 },
        { month: 'Feb', price: 11200000 },
        { month: 'Mar', price: 11500000 },
        { month: 'Apr', price: 11400000 },
        { month: 'May', price: 11800000 },
        { month: 'Jun', price: 12000000 }
      ]
    },
    Lahore: {
      avgPrice: 'PKR 95 Lac',
      growth: '+6.2%',
      mostPopular: 'DHA Phase 5',
      transactions: '2,341',
      priceHistory: [
        { month: 'Jan', price: 8900000 },
        { month: 'Feb', price: 9000000 },
        { month: 'Mar', price: 9200000 },
        { month: 'Apr', price: 9100000 },
        { month: 'May', price: 9300000 },
        { month: 'Jun', price: 9500000 }
      ]
    },
    Islamabad: {
      avgPrice: 'PKR 1.5 Crore',
      growth: '+10.1%',
      mostPopular: 'Bahria Town',
      transactions: '1,923',
      priceHistory: [
        { month: 'Jan', price: 13600000 },
        { month: 'Feb', price: 13900000 },
        { month: 'Mar', price: 14300000 },
        { month: 'Apr', price: 14500000 },
        { month: 'May', price: 14800000 },
        { month: 'Jun', price: 15000000 }
      ]
    }
  };

  const cityData = trendsData[selectedCity];
  const maxPrice = Math.max(...cityData.priceHistory.map(d => d.price));
  const minPrice = Math.min(...cityData.priceHistory.map(d => d.price));

  const formatPrice = (price) => {
    return `${(price / 10000000).toFixed(1)}Cr`;
  };

  return (
    <div className="trends-modal-overlay" onClick={onClose}>
      <div className="trends-modal" onClick={(e) => e.stopPropagation()}>
        <div className="trends-header">
          <h2>Property Market Trends</h2>
          <button className="btn-close" onClick={onClose} aria-label="Close trends">
            <CloseIcon size={24} color="#636e72" />
          </button>
        </div>

        <div className="trends-body">
          <div className="city-selector">
            {Object.keys(trendsData).map(city => (
              <button
                key={city}
                className={`city-tab ${selectedCity === city ? 'active' : ''}`}
                onClick={() => setSelectedCity(city)}
              >
                {city}
              </button>
            ))}
          </div>

          <div className="trends-stats">
            <div className="stat-card">
              <div className="stat-label">Average Price</div>
              <div className="stat-value">{cityData.avgPrice}</div>
              <div className={`stat-change ${cityData.growth.includes('+') ? 'positive' : 'negative'}`}>
                {cityData.growth} this quarter
              </div>
            </div>

            <div className="stat-card">
              <div className="stat-label">Most Popular Area</div>
              <div className="stat-value">{cityData.mostPopular}</div>
              <div className="stat-meta">Top searched location</div>
            </div>

            <div className="stat-card">
              <div className="stat-label">Transactions</div>
              <div className="stat-value">{cityData.transactions}</div>
              <div className="stat-meta">Last 30 days</div>
            </div>
          </div>

          <div className="price-chart">
            <h3>6-Month Price Trend</h3>
            <div className="chart-container">
              <div className="chart-y-axis">
                <span>{formatPrice(maxPrice)}</span>
                <span>{formatPrice((maxPrice + minPrice) / 2)}</span>
                <span>{formatPrice(minPrice)}</span>
              </div>
              <div className="chart-area">
                {cityData.priceHistory.map((data, index) => {
                  const height = ((data.price - minPrice) / (maxPrice - minPrice)) * 100;
                  return (
                    <div key={index} className="chart-bar-wrapper">
                      <div
                        className="chart-bar"
                        style={{ height: `${height}%` }}
                      >
                        <div className="bar-tooltip">{formatPrice(data.price)}</div>
                      </div>
                      <div className="chart-label">{data.month}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="trends-insights">
            <h3>Market Insights</h3>
            <div className="insights-grid">
              <div className="insight-item">
                <div className="insight-icon positive">↑</div>
                <div className="insight-content">
                  <div className="insight-title">High Demand</div>
                  <div className="insight-desc">Properties in {cityData.mostPopular} selling 40% faster</div>
                </div>
              </div>
              <div className="insight-item">
                <div className="insight-icon neutral">≈</div>
                <div className="insight-content">
                  <div className="insight-title">Stable Market</div>
                  <div className="insight-desc">Prices expected to remain steady for Q3 2024</div>
                </div>
              </div>
              <div className="insight-item">
                <div className="insight-icon positive">★</div>
                <div className="insight-content">
                  <div className="insight-title">Best Time to Buy</div>
                  <div className="insight-desc">Current rates {cityData.growth} below peak</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyTrends;
